import { Alert, schPairedCostRouteItem } from '@aloft/toolkit-shared';

import { schAppraisifyValidation } from '../../../../hooks/validation/schemas.ts';
import { SubjectPropertyDataState } from '../../../../redux/types.ts';
import { toOrderDetailsTargetCellKey } from '../../../orderDetails/orderDetailsFieldFocus.ts';
import { AlertDefinition } from '../../types.ts';
import { getAlertTriggers } from '../utils/alertTriggers.ts';

const schOrderDetailsValidation = schAppraisifyValidation.shape.orderDetails;

export const missingOrderDetailsData: AlertDefinition = ({ order, propertyDataEntities }) => {
  const subjectEntity = propertyDataEntities.subject;
  if (!subjectEntity || subjectEntity.id !== 'subject') {
    return undefined;
  }

  const identification = (subjectEntity as SubjectPropertyDataState).subjectData.editableData
    .propertyIdentification;

  const result = schOrderDetailsValidation.safeParse({
    zoning: identification?.zoning ?? '',
    zoningCompliance: identification?.zoningCompliance ?? '',
    parcelNumber: identification?.parcelNumber ?? '',
    newConstruction: identification?.newConstruction ?? false,
    legalDescription: identification?.legalDescription ?? '',
    hoa: identification?.hoa ?? '',
    effectiveDate: order.effectiveDate ?? '',
    intendedUsers: order.intendedUsers ?? '',
    intendedUse: order.intendedUse ?? '',
    locationType: identification?.locationType ?? '',
    propertyInterest: identification?.propertyInterest ?? '',
    propertyInterestOther: identification?.propertyInterestOther ?? '',
  });

  if (result.success) {
    return undefined;
  }

  const firstIssuePath = result.error.issues[0]?.path;
  const fieldName = firstIssuePath?.[0];
  const targetCellKey = typeof fieldName === 'string' ? toOrderDetailsTargetCellKey(fieldName) : undefined;

  return {
    type: 'missingOrderDetailsData',
    status: 'active',
    severity: 'error',
    orderType: ['appraisify'],
    message: 'Order has missing required fields.',
    fixingInfo: {
      tips: 'Complete all required fields on the Order page.',
      pairedCostRouteItem: schPairedCostRouteItem.enum.details,
      fixingMethod: ['action'],
      commentAlwaysRequired: false,
      targetCellKey,
    },
    triggers: getAlertTriggers({ fixRoute: 'details', order }),
  } as Alert;
};
